import {GraphView, IGraphViewProps} from 'react-digraph';
import {PIPELINE_GRAPH_NODE_KEY, PipelineGraphConfig} from './config';

export type BasePipelineGraphViewProps = Omit<
    IGraphViewProps,
    'nodeKey' | 'nodeTypes' | 'nodeSubtypes' | 'edgeTypes'
>;

export const BasePipelineGraphView = (props: BasePipelineGraphViewProps) => {
    return (
        <GraphView
            {...props}
            nodeKey={PIPELINE_GRAPH_NODE_KEY}
            nodeTypes={PipelineGraphConfig.NodeTypes}
            nodeSubtypes={PipelineGraphConfig.NodeSubtypes}
            edgeTypes={PipelineGraphConfig.EdgeTypes}
        />
    );
};
